(() => {
  if (window.clutchCollectionCardInitialized) return;
  window.clutchCollectionCardInitialized = true;

  const quantitySelector = '.clutch-card-quantity__input';

  function updateQuantityState(input) {
    if (!input) return;

    const min = Number.parseInt(input.min || '1', 10);
    const parsedMax = Number.parseInt(input.max || '', 10);
    const max = Number.isFinite(parsedMax) ? parsedMax : Infinity;

    let value = Number.parseInt(input.value || String(min), 10);

    if (!Number.isFinite(value)) value = min;

    value = Math.max(min, Math.min(value, max));
    input.value = String(value);

    const wrapper = input.closest('[data-clutch-quantity]');
    if (!wrapper) return;

    const minus = wrapper.querySelector('[data-clutch-minus]');
    const plus = wrapper.querySelector('[data-clutch-plus]');

    if (minus) minus.disabled = value <= min;
    if (plus) plus.disabled = value >= max;
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest(
      '[data-clutch-minus], [data-clutch-plus]'
    );

    if (!button) return;

    const wrapper = button.closest('[data-clutch-quantity]');
    const input = wrapper
      ? wrapper.querySelector(quantitySelector)
      : null;

    if (!input) return;

    const current = Number.parseInt(input.value || '1', 10);
    const change = button.hasAttribute('data-clutch-plus') ? 1 : -1;

    input.value = String(current + change);
    updateQuantityState(input);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('input', function (event) {
    if (!event.target.matches(quantitySelector)) return;
    updateQuantityState(event.target);
  });

  document.addEventListener('change', function (event) {
    const select = event.target.closest(
      '[data-clutch-condition-select]'
    );

    if (!select) return;

    const form = select.closest('form.clutch-card-form');
    if (!form) return;

    const option = select.options[select.selectedIndex];
    const variantInput = form.querySelector('.clutch-card-variant-id');
    const price = form.querySelector('.clutch-selected-price');
    const quantityInput = form.querySelector(quantitySelector);
    const submitButton = form.querySelector('[name="add"]');
    const available = option.dataset.available === 'true';

    if (variantInput) {
      variantInput.value = option.value;
      variantInput.disabled = !available;
      variantInput.dispatchEvent(
        new Event('change', { bubbles: true })
      );
    }

    if (price && option.dataset.price) {
      price.textContent = option.dataset.price;
    }

    if (quantityInput) {
      const maximum = Number.parseInt(
        option.dataset.max || '',
        10
      );

      if (Number.isFinite(maximum) && maximum >= 0) {
        quantityInput.max = String(maximum);
      } else {
        quantityInput.removeAttribute('max');
      }

      quantityInput.value = '1';
      updateQuantityState(quantityInput);
    }

    if (submitButton) {
      submitButton.disabled = !available;
    }
  });

  document
    .querySelectorAll(quantitySelector)
    .forEach(updateQuantityState);
})();